import React from 'react';
import { CardContainer, ContainerBase } from '../containers';
import { Title } from '../title';
import { FAQS, Information } from 'const/landing';
import { Button, CustomAccordion } from 'components/common';
import { customEvent } from '@/lib';
import { useRouter } from 'next/router';
import { useMediaQuery } from 'react-responsive';
import clsx from 'clsx';

interface Props {
	title?: string;
	className?: string;
	classNameTitle?: string;
	classNameDescription?: string;
	classContainerFaqs?: string;
}

export const Faqs: React.FC<Props> = ({
	title,
	className,
	classNameTitle,
	classNameDescription,
	classContainerFaqs,
}) => {
	const [currentFaqs, setCurrentFaqs] = React.useState<Information[]>([]);
	const router = useRouter();
	const isDesktopOrLaptop = useMediaQuery({
		query: '(min-width: 1024px)',
	});

	React.useEffect(() => {
		const items = FAQS.map((question) => {
			return question;
		}).filter((_, index) => (isDesktopOrLaptop ? index < 6 : index < 4));

		setCurrentFaqs(items);
	}, [isDesktopOrLaptop]);

	return (
		<ContainerBase
			className={clsx(
				'px-0 md:px-5 mt-[76px] lg:mt-[100px] 2xl:mt-[144px] flex flex-col items-center',
				className
			)}
		>
			<CardContainer className="relative bg-white pt-8 pb-8 !rounded-[32px] lg:!rounded-[64px]">
				<Title
					description="Everything You Need to Know About Simplifying Your Legal Journey"
					classNameTitle={clsx(
						' md:min-w-[535px] leading-tight',
						classNameTitle
					)}
					classNameDescription={clsx('hidden md:block', classNameDescription)}
				>
					{title ? (
						title
					) : (
						<>
							Have Questions?
							<br />
							<span className="text-primary">We Have Answers</span>
						</>
					)}
				</Title>
				<div
					className={clsx(
						'w-full lg:max-w-4xl px-4 pt-2 lg:pt-16 lg:px-[3.2rem] m-auto z-0',
						classContainerFaqs
					)}
				>
					<CustomAccordion information={currentFaqs} />
				</div>
				<div className="w-full px-4">
					<Button
						decoration={'line-primary'}
						size="medium"
						className="mt-8 md:mt-16 m-auto xl:px-[23px]  md:!w-[156px]  md:!h-12"
						onClick={() => {
							customEvent({
								action: 'faq_click',
								category: 'landing',
								label: 'View all FAQs',
								value: 'View all FAQs',
								callback: () => router.push(`/faqs`),
							});
						}}
					>
						View all FAQs
					</Button>
				</div>
			</CardContainer>
		</ContainerBase>
	);
};
